export default __webpack_public_path__ + "static/media/0-deg.091f33c6.svg";